import { render, staticRenderFns } from "./waybillTrajectory.vue?vue&type=template&id=72aa775a&scoped=true"
import script from "./waybillTrajectory.vue?vue&type=script&lang=js"
export * from "./waybillTrajectory.vue?vue&type=script&lang=js"
import style0 from "./waybillTrajectory.vue?vue&type=style&index=0&id=72aa775a&prod&scoped=true&lang=css"
import style1 from "./waybillTrajectory.vue?vue&type=style&index=1&id=72aa775a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72aa775a",
  null
  
)

export default component.exports